<template>
  <div class="card card-default">
    <div class="card-header pb-0">
      <div class="product-heading mt-3">
        <h4>{{ productHeading }}</h4>
      </div>
      <div class="random-sale--button" v-if="productNumber != 0 && saleDefinitions.includes(productDetail.productDefinition) && saleExists">
        <button
          class="btn btn-success float-left ml-0"
          @click="goToRandomSale"
          v-allowed:view="['STAFF']"
        >
          View random sale for this product
        </button>
      </div>
    </div>
    <hr />
    <div class="card-body">
      <div class="product-setup--tabs">
        <ul class="nav nav-tabs" role="tablist">
          <li class="nav-item" v-for="item in navItems" :key="item.name">
            <a
              :href="item.link"
              :class="item.class"
              :id="item.id"
              data-toggle="tab"
              role="tab"
              :aria-controls="item.controls"
              aria-selected="true"
            >
              <i :class="item.icon"></i>
              {{ item.name }}
            </a>
          </li>
        </ul>
        <div class="tab-content">
          <div class="tab-pane active show" id="detail">
            <div class="row row-spacing">
              <div class="col-md-12">
                <div class="row row-spacing">
                  <div class="col-md-12">
                    <div class="row">
                      <div class="col-md-12">
                        <h4>Product Information</h4>
                      </div>
                    </div>
                    <hr>
                    <div class="row">
                        <div class="form-group col-md-2">
                          <label>Product Number</label>
                          <input type="text" class="form-control" v-model="productDetail.productNumber" disabled>
                        </div>
                        <div class="form-group col-md-7">
                          <label>Product Description</label>
                          <input type="text" class="form-control" v-model="productDetail.description" :disabled="!isAdminUser && !isAuthorizedUser">
                        </div>
                        <div class="form-group col-md-3">
                          <label>For Sale</label>
                          <select
                            v-model="productDetail.forSale"
                            class="form-control"
                            :disabled="!isAdminUser && !isAuthorizedUser"
                          >
                            <option :value="true">Yes</option>
                            <option :value="false">No</option>
                          </select>
                        </div>
                    </div>
                    <div class="row">
                      <div class="form-group col-md-2">
                        <label>Publish to Halo</label>
                        <select
                          v-model="productDetail.publish"
                          class="form-control"
                          :disabled="!isAdminUser && !isAuthorizedUser"
                        >
                          <option :value="true">Yes</option>
                          <option :value="false">No</option>
                        </select>
                      </div>

                      <div class="form-group col-md-2">
                        <label>Wholesale Product</label>
                        <select
                          v-model="productDetail.wholesale"
                          class="form-control"
                          :disabled="!isAdminUser && !isAuthorizedUser"
                        >
                          <option :value="true">Yes</option>
                          <option :value="false">No</option>
                        </select>
                      </div>
                      <div class="form-group col-md-2">
                        <label>Priced From Quote</label>
                        <select
                          v-model="productDetail.pricedFromQuote"
                          class="form-control"
                          :disabled="!isAdminUser && !isAuthorizedUser"
                        >
                          <option :value="true">Yes</option>
                          <option :value="false">No</option>
                        </select>
                      </div>
                      <div class="form-group col-md-3">
                        <label>Product Restrictions</label>
                        <select
                          v-model="productDetail.clientAccessRestriction"
                          class="form-control"
                          :disabled="!isAdminUser && !isAuthorizedUser"
                        >
                          <option
                            :value="restriction.description"
                            v-for="restriction in productRestrictions"
                            :key="restriction.name"
                          >
                            {{ restriction.description }}
                          </option>
                        </select>
                      </div>
                      <div class="form-group col-md-3">
                        <label>Wizard Restrictions</label>
                        <select
                          v-model="productDetail.wizardAccessRestriction"
                          class="form-control"
                          :disabled="!isAdminUser && !isAuthorizedUser"
                        >
                          <option
                            :value="restriction.description"
                            v-for="restriction in wizardRestrictions"
                            :key="restriction.name"
                          >
                            {{ restriction.description }}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row row-spacing">
                  <div class="col-md-12">
                    <div class="row">
                      <div class="col-md-12">
                        <h4>Product Classification</h4>
                      </div>
                    </div>
                    <hr />
                    <div class="row">
                      <div class="form-group col-md-4">
                        <label>Type</label>
                        <select
                          v-model="productDetail.classificationType"
                          class="form-control"
                          :disabled="!isAdminUser && !isAuthorizedUser"
                        >
                          <option
                            v-for="classType in productClassificationTypes"
                            :value="classType"
                            :key="classType"
                          >
                            {{ classType }}
                          </option>
                      </select>
                      </div>
                      <div class="form-group col-md-4">
                        <label>Supplier</label>
                        <select
                          v-model="productDetail.supplierNumber"
                          class="form-control"
                          :disabled="!isAdminUser && !isAuthorizedUser"
                        >
                          <option
                            :value="supplier.supplierNumber"
                            v-for="supplier in suppliers"
                            :key="supplier.supplierNumber"
                          >
                            {{ supplier.name }}
                          </option>
                        </select>
                      </div>
                      <div class="form-group col-md-4">
                        <label>Vendor</label>
                        <select
                          v-model="productDetail.vendorNumber"
                          class="form-control"
                          :disabled="!isAdminUser && !isAuthorizedUser"
                          @change="getProductSegments()"
                        >
                          <option
                            :value="vendor.vendorNumber"
                            v-for="vendor in vendors"
                            :key="vendor.vendorNumber"
                          >
                            {{ vendor.name }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div class="row">
                      <div class="form-group col-md-4">
                        <label>Segment</label>
                        <select
                          v-model="productDetail.segmentNumber"
                          class="form-control"
                          :disabled="!isAdminUser && !isAuthorizedUser"
                           @change="getSubSegmentsForSegment(productDetail.segmentNumber)"
                        >
                          <option
                            :value="segment.segmentNumber"
                            v-for="segment in segments"
                            :key="segment.segmentNumber"
                          >
                            {{ segment.name}}
                          </option>
                        </select>
                      </div>
                      <div class="form-group col-md-4">
                        <label>Subsegment</label>
                        <select
                          v-model="productDetail.subSegmentNumber"
                          class="form-control"
                          :disabled="!isAdminUser && !isAuthorizedUser"
                        >
                          <option
                            :value="subsegment.subSegmentNumber"
                            v-for="subsegment in subSegments"
                            :key="subsegment.subSegmentNumber"
                          >
                            {{ subsegment.name }}
                          </option>
                        </select>
                      </div>
                      <div class="col-md-4">
                        <div class="form-group">
                          <label>Sale Definition</label>
                          <select
                            v-model="productDetail.productDefinition"
                            class="form-control"
                            :disabled="!isAdminUser && !isAuthorizedUser"
                          >
                            <option
                              v-for="def in saleDefinitions"
                              :value="def"
                              :key="def"
                            >
                              {{ def }}
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <hr />
            <div class="row mb-4">
              <div class="col-md-12 mt-4">
                <div class="row">
                  <div class="col">
                    <button class="btn btn-success" v-if="isAdminUser || isAuthorizedUser || productDetail.productDefinition" @click="saveProduct">Save</button>
                    <button class="btn" @click="goToProductsList">Back</button>
                    <button class="btn btn-link" v-if="isAdminUser || isAuthorizedUser && productNumber != 0" @click="cloneProduct">Clone</button>
                    <button class="btn btn-link text-red" v-if="isAdminUser || isAuthorizedUser && productNumber != 0" @click="deleteProduct">Delete</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="tab-pane" id="config">
            <div class="row row-spacing">
              <div class="col-md-12">
                    <div class="row row-spacing">
                      <div class="col-md-12">
                        <h4>Product Variables</h4>
                      </div>
                    </div>
                    <hr />
                    <div class="row">
                      <div class="col-md-12">
                        <div class="table-responsive table-bordered">
                          <table class="table">
                            <thead>
                              <tr>
                                <th>Description</th>
                                <th>Value</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                v-for="(variable, index) in productDetail.productvariables"
                                :key="index"
                                :class="{'product-var-removed': variable.removed,'product-var-added': variable.added,}">
                                <td>
                                  <i class="fa fa-minus-circle" title="Product var not in Sale Def anymore" v-if="variable.removed"></i>
                                  <i class="fa fa-plus-circle" title="Product var added to Sale Def and this product needs a value" v-if="variable.added"></i>
                                  <span>{{ variable.description }}:</span>
                                </td>
                                <td>
                                  <span class="badge" :class="getProductVarTypeClass(variable.type)" style="margin-bottom: 5px">
                                    {{ variable.type }}
                                  </span>
                                  <input v-model="variable.value" class="form-control col-md-3" :disabled="variable.removed || !isAdminUser && !isAuthorizedUser" />
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
              </div>
            </div>
            <hr />
            <div class="row mb-4">
              <div class="col-md-12 mt-4">
                <div class="row">
                  <div class="col">
                    <button class="btn btn-success" v-if="isAdminUser || isAuthorizedUser || productDetail.productDefinition" @click="saveProduct">Save</button>
                    <button class="btn" @click="goToProductsList">Back</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="tab-pane" id="pricing">
            <div class="row row-spacing" v-if="!pricingRouteName">
              <div class="col-md-12">
                <div class="text-center text-muted py-5">
                  <i class="fa fa-info-circle fa-2x mb-3"></i>
                  <p class="mb-0">No Price Configuration available</p>
                </div>
              </div>
            </div>
            <div class="row row-spacing" v-if="pricingRouteName">
              <div class="col-md-12">
                  <FtthCappedPricing
                    v-if="pricingRouteName === 'ftthcappedpricing'"
                    :productNumber="productDetail.productNumber"
                    :userEditRight="isAdminUser || isAuthorizedUser"
                  />
                  <FtthUncappedPricing
                    v-else-if="pricingRouteName === 'ftthuncappedpricing'"
                    :productNumber="productDetail.productNumber"
                    :userEditRight="isAdminUser || isAuthorizedUser"
                    :hasAdditionalBilling="true"
                  />
                  <FttbPricing
                    v-else-if="pricingRouteName === 'fttbpricing'"
                    :productNumber="productDetail.productNumber"
                    :userEditRight="isAdminUser || isAuthorizedUser"
                  />
                  <AxxessLtePricing
                    v-else-if="pricingRouteName === 'axxessltepricing'"
                    :productNumber="productDetail.productNumber"
                    :productSupplier="getSupplier(productDetail)"
                    :userEditRight="isAdminUser || isAuthorizedUser"
                  />
                  <AxxessLtePricing
                    v-else-if="pricingRouteName === 'axxessltepricingl2tp'"
                    :productNumber="productDetail.productNumber"
                    :productSupplier="getSupplier(productDetail)"
                    :userEditRight="isAdminUser || isAuthorizedUser"
                  />
                  <WirelessLtePricing
                    v-else-if="pricingRouteName === 'wirelessltepricing'"
                    :productNumber="productDetail.productNumber"
                    :productSupplier="getSupplier(productDetail)"
                    :userEditRight="isAdminUser || isAuthorizedUser"
                  />
                  <DomainRegistrationPricing
                    v-else-if="pricingRouteName === 'domainregistrationpricing'"
                    :productNumber="productDetail.productNumber"
                    :userEditRight="isAdminUser || isAuthorizedUser"
                  />
                  <CPanelHostingPricing
                    v-else-if="pricingRouteName === 'cpanelhostingpricing'"
                    :productNumber="productDetail.productNumber"
                    :userEditRight="isAdminUser || isAuthorizedUser"
                  />
                  <SupportServicePricing
                    v-else-if="pricingRouteName === 'supportservicepricing'"
                    :productNumber="productDetail.productNumber" :pricingScreen="true"
                    :userEditRight="isAdminUser || isAuthorizedUser"
                  />
                  <BasicPricing
                    v-else-if="pricingRouteName === 'basicpricing'"
                    :productNumber="productDetail.productNumber"
                    :userEditRight="isAdminUser || isAuthorizedUser"
                  />
                  <RouterRentalPricing
                    v-else-if="pricingRouteName === 'routerrentalpricing'"
                    :productNumber="productDetail.productNumber"
                    :userEditRight="isAdminUser || isAuthorizedUser"
                  />
                  <VirtualServerPricing
                    v-else-if="pricingRouteName === 'virtualserverpricing'"
                    :productNumber="productDetail.productNumber"
                    :userEditRight="isAdminUser || isAuthorizedUser"
                  />
                  <HostAfricaServerPricing
                    v-else-if="pricingRouteName === 'hostafricaserverpricing'"
                    :productNumber="productDetail.productNumber"
                    :userEditRight="isAdminUser || isAuthorizedUser"
                  />
                  <SplaServicePricing
                    v-else-if="pricingRouteName === 'SplaServicePricing'"
                    :productNumber="productDetail.productNumber"
                    :userEditRight="isAdminUser || isAuthorizedUser"
                  />
                  <SolarwindsBackupPricing
                    v-else-if="pricingRouteName === 'solarwindsbackuppricing'"
                    :productNumber="productDetail.productNumber"
                    :userEditRight="isAdminUser || isAuthorizedUser"
                  />
                  <WanatelCloudPbxPricing
                    v-else-if="pricingRouteName === 'wanta'"
                    :productNumber="productDetail.productNumber"
                    :userEditRight="isAdminUser || isAuthorizedUser"
                  />
                  <Cx3PbxPricing
                    v-else-if="pricingRouteName === 'cx3pbxpricing'"
                    :productNumber="productDetail.productNumber"
                    :userEditRight="isAdminUser || isAuthorizedUser"
                  />
                  <Cx3CallVaultPricing
                    v-else-if="pricingRouteName === 'cx3callvaultpricing'"
                    :productNumber="productDetail.productNumber"
                    :userEditRight="isAdminUser || isAuthorizedUser"
                  />
                  <ZimbraMailPricing
                    v-else-if="pricingRouteName === 'zimbramailpricing'"
                    :productNumber="productDetail.productNumber"
                    :userEditRight="isAdminUser || isAuthorizedUser"
                  />
                  <PrivateApnPackagePricing
                    v-else-if="pricingRouteName === 'mtnapnpricing'"
                    :productNumber="productDetail.productNumber"
                    :userEditRight="isAdminUser || isAuthorizedUser"
                  />
                  <Layer3Pricing
                    v-else-if="pricingRouteName === 'layer3pricing'"
                    :productNumber="productDetail.productNumber"
                    :userEditRight="isAdminUser || isAuthorizedUser"
                  />
                  <CyberRiskAwarePricing
                    v-else-if="pricingRouteName === 'cyberriskawarepricing'"
                    :productNumber="productDetail.productNumber"
                    :userEditRight="isAdminUser || isAuthorizedUser"
                  />
                  <BandwidthPricing
                    v-else-if="pricingRouteName === 'BandwidthPricing'"
                    :productNumber="productDetail.productNumber"
                    :userEditRight="isAdminUser || isAuthorizedUser"
                  />
                  <NetworkRangePricing
                    v-else-if="pricingRouteName === 'NetworkRangePricing'"
                    :productNumber="productDetail.productNumber"
                    :userEditRight="isAdminUser || isAuthorizedUser"
                  />
                  <AxxessFtthPricing
                    v-else-if="pricingRouteName === 'axxessftthpricing'"
                    :productNumber="productDetail.productNumber"
                    :userEditRight="isAdminUser || isAuthorizedUser"
                  />
                  <WebsiteZimbraPricing
                    v-else-if="pricingRouteName === 'WebsiteZimbraPricing'"
                    :productNumber="productDetail.productNumber"
                    :userEditRight="isAdminUser || isAuthorizedUser"          
                  />
                  <WebsitePhpPricing
                    v-else-if="pricingRouteName === 'WebsitePhpPricing'"
                    :productNumber="productDetail.productNumber"
                    :userEditRight="isAdminUser || isAuthorizedUser"          
                  />
                  <CabinetPowerPricing
                    v-else-if="pricingRouteName === 'CabinetPowerPricing'"
                    :productNumber="productDetail.productNumber"
                    :userEditRight="isAdminUser || isAuthorizedUser"          
                  />
                  <InternalDnsPricing
                    v-else-if="pricingRouteName === 'internaldnspricing'"
                    :productNumber="productDetail.productNumber"
                    :userEditRight="isAdminUser || isAuthorizedUser"
                  />
                  <DeviceManagementPricing
                    v-else-if="pricingRouteName === 'devicepricing'"
                    :productNumber="productDetail.productNumber"
                    :userEditRight="isAdminUser || isAuthorizedUser"
                  />
                  <GenericApnPricing
                    v-else-if="pricingRouteName === 'GenericApnPricing'"
                    :productNumber="productDetail.productNumber"
                    :productSupplier="getSupplier(productDetail)"
                    :userEditRight="isAdminUser || isAuthorizedUser"
                  />
                  <RocketseedServicePricing
                    v-else-if="pricingRouteName === 'rocketseedpricing'"
                    :productNumber="productDetail.productNumber"
                    :productSupplier="getSupplier(productDetail)"
                    :userEditRight="isAdminUser || isAuthorizedUser"
                  />
                  <QuotationPackages
                    v-else-if="pricingRouteName === 'quotationpackages' && vendors.length > 0"
                    :productNumber="productDetail.productNumber"
                    :productVendor="currentVendorName"
                    :userEditRight="isAdminUser || isAuthorizedUser"
                    :pricedFromQuote="productDetail.pricedFromQuote"
                  />
                  <MicrosoftQuotations
                    v-else-if="pricingRouteName === 'microsoftquotations'"
                    :productNumber="productDetail.productNumber"
                    :productSupplier="getSupplier(productDetail)"
                    :userEditRight="isAdminUser || isAuthorizedUser"
                  />

                  <strong style="color: red" v-else
                    >Pricing Page not set for Product</strong
                  >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { 
  productNameExists,
  getProduct, 
  getRandomSaleForProduct, 
  getProductClassificationTypes, 
  getProductRestrictions, 
  getProductWizardRestrictions,
  getProductClone,
  saveProduct,
  deleteProduct
} from "@/api/v1/products.api";
import { getSuppliers } from "@/api/v2/suppliers.api";
import { getVendors } from "@/api/v2/vendors.api";
import { getSegments } from "@/api/v2/segments.api";
import { getSubSegments } from "@/api/v2/subsegments.api";
import { getSaleDefinitions, getLegacySaleDefinitions, getSaleDefinitionProductVariables } from "@/api/v1/sales.api";

import FtthCappedPricing from "@/components/Admin/FtthCappedPricing";
import FtthUncappedPricing from "@/components/Admin/FtthUncappedPricing";
import FttbPricing from "@/components/Admin/FttbPricing";
import AxxessLtePricing from "@/components/Admin/AxxessLtePricing";
import WirelessLtePricing from "@/components/Admin/WirelessLtePricing";
import CPanelHostingPricing from "@/components/Admin/CPanelHostingPricing";
import DomainRegistrationPricing from "@/components/Admin/DomainRegistrationPricing";
import SupportServicePricing from "@/components/Admin/SupportServicePricing";
import BasicPricing from "@/components/Admin/BasicPricing";
import RouterRentalPricing from "@/components/Admin/RouterRentalPricing";
import VirtualServerPricing from "@/components/Admin/VirtualServerPricing";
import HostAfricaServerPricing from "@/components/Admin/HostAfricaServerPricing";
import SplaServicePricing from "@/components/Admin/SplaServicePricing";
import SolarwindsBackupPricing from "@/components/Admin/SolarwindsBackupPricing";
import WanatelCloudPbxPricing from "@/components/Admin/WanatelCloudPbxPricing";
import Cx3PbxPricing from "@/components/Admin/Cx3PbxPricing";
import Cx3CallVaultPricing from "@/components/Admin/Cx3CallVaultPricing";
import ZimbraMailPricing from "@/components/Admin/ZimbraMailPricing";
import PrivateApnPackagePricing from "@/components/Admin/PrivateApnPackagePricing";
import BandwidthPricing from "@/components/Admin/BandwidthPricing";
import NetworkRangePricing from "@/components/Admin/NetworkRangePricing";
import Layer3Pricing from "@/components/Admin/Layer3Pricing";
import DeviceManagementPricing from "@/components/Admin/DeviceManagementPricing";
import CyberRiskAwarePricing from "@/components/Admin/CyberRiskAwarePricing";
import AxxessFtthPricing from "@/components/Admin/AxxessFtthPricing";
import WebsiteZimbraPricing from "@/components/Admin/WebsiteZimbraPricing";
import WebsitePhpPricing from "@/components/Admin/WebsitePhpPricing";
import CabinetPowerPricing from "@/components/Admin/CabinetPowerPricing";
import InternalDnsPricing from "@/components/Admin/InternalDnsPricing";
import GenericApnPricing from "@/components/Admin/GenericApnPricing"
import QuotationPackages from "@/components/Admin/QuotationPackages"
import RocketseedServicePricing from "@/components/Admin/RocketseedServicePricing";
import MicrosoftQuotations from "@/components/Admin/MicrosoftQuotations";

  export default {
    components: {
      FtthCappedPricing,
      FtthUncappedPricing,
      FttbPricing,
      AxxessLtePricing,
      WirelessLtePricing,
      CPanelHostingPricing,
      DomainRegistrationPricing,
      SupportServicePricing,
      BasicPricing,
      RouterRentalPricing,
      VirtualServerPricing,
      HostAfricaServerPricing,
      SplaServicePricing,
      SolarwindsBackupPricing,
      WanatelCloudPbxPricing,
      Cx3PbxPricing,
      Cx3CallVaultPricing,
      ZimbraMailPricing,
      PrivateApnPackagePricing,
      Layer3Pricing,
      DeviceManagementPricing,
      CyberRiskAwarePricing,
      BandwidthPricing,
      NetworkRangePricing,
      AxxessFtthPricing,
      WebsiteZimbraPricing,
      WebsitePhpPricing,
      CabinetPowerPricing,
      InternalDnsPricing,
      GenericApnPricing,
      QuotationPackages,
      RocketseedServicePricing,
      MicrosoftQuotations
    },
    data() {
      return {
        productNumber: 0,
        productDetail: {
          productvariables: [],
        },
        randomSale: {},
        navItems: [
          {
            link: "#detail",
            class: "nav-link active",
            id: "detail-tab",
            controls: "detail",
            name: "Detail",
            icon: "fa-solid fa-circle-info",
            show: true
          },
          {
            link: "#config",
            class: "nav-link",
            id: "config-tab",
            controls: "config",
            name: "Configuration",
            icon: "fa-solid fa-gears",
            show: true
          },
          {
            link: "#pricing",
            class: "nav-link",
            id: "pricing-tab",
            controls: "pricing",
            name: "Pricing",
            icon: "fa-regular fa-money-bill-1",
            show: false
          },
        ],
        productClassificationTypes: [],
        productRestrictions: [],
        wizardRestrictions: [],
        suppliers: [],
        vendors: [],
        segments: [],
        subSegments: [],
        saleDefinitions: [],
        pricingRouteName: null,
        saleExists: false,
        inititalProductVariables: [],
        savedProductDescription: null
      }
    },
    async mounted() {
      this.productNumber = this.$route.params.productNumber;
      this.$root.$emit("SET_PAGE_TITLE", "Product");

      try {
        await Promise.all([
          this.getProductTypes(),
          this.getProductVendors(),
          this.getProductSuppliers(),
          this.getProductSegments()
        ]);

        this.getExistingProduct();
        
        this.getSaleDefinitions();
        this.getRestrictions();
        this.getWizardRestrictions();  
      } catch (error) {
        console.error("Failed to initialize product data", error);
      }
    },
    computed: {
      productHeading() {
        return this.productDetail.description ? `${this.productDetail.description} [${this.productDetail.productNumber}]` : 'New Product';
      },
      isAdminUser() {
        return this.userContainsPermission(['ADMIN']);
      },
      isAuthorizedUser() {
        return this.userContainsPermission(['PRODUCT_MANAGER']);
      },
      currentVendorName() {
        if (!this.vendors.length || !this.productDetail.vendorNumber) {
          return null; 
        }
        const vendor = this.vendors.find((v) => v.vendorNumber === this.productDetail.vendorNumber);
        return vendor ? vendor.name : "Vendor not found";
      }
    },
    methods: {
      getExistingProduct: function() {
        getProduct(this.productNumber)
        .then((response) => {
          this.productDetail = response.data;
          this.savedProductDescription = this.productDetail.description;
          
          document.title = this.productDetail.description;           
          const productDefinitionMetaData = this.getProductDefinition(this.productDetail.productDefinition);
          this.pricingRouteName = productDefinitionMetaData.pricingRouteName;
          this.inititalProductVariables = this.deepCopyObject(this.productDetail.productvariables);

          this.getSaleDefinitions();
          this.salePresent();
          this.getProductVariables();
          this.getRestrictions();
          this.getWizardRestrictions();
          this.getSubSegmentsForSegment(this.productDetail.segmentNumber);    

          const tabs = this.navItems;

          if (this.pricingRouteName) {
              tabs.filter((tab) => {
                tab.show = true
              }
            );
          }
        })
        .catch((error) => {
          console.error(error.response.data);
          this.showError("Error fetching product", error.response);
        });
      },
      salePresent: function() {
        getRandomSaleForProduct(this.productNumber)
        .then(() => {
          this.saleExists = true;
        })
        .catch(() => {
          this.saleExists = false;
        });
      },
      saveProduct: function() {
        this.confirmProductName()
        .then((confirmed) => {
          if (confirmed) {
            this.persistProduct();
          }
        })
        .catch((error) => {
          console.error(error.response && error.response.data ? error.response.data : error);
          this.showError("Error checking product name", error.response || error);
        });
      },
      confirmProductName: function() {
        const currentDescription = this.productDetail.description || "";
        const description = currentDescription.trim().toLowerCase();

        if (!description || currentDescription === this.savedProductDescription) {
          return Promise.resolve(true);
        }

        return productNameExists(
          this.productDetail.description,
          this.productDetail.productNumber
        )
        .then((response) => {
          if (!response.data) {
            return true;
          }

          return this.$swal({
            title: "Duplicate product name",
            text: "There are other products with this name. Are you sure you want to save it with this name?",
            type: "warning",
            showCancelButton: true,
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes",
          }).then((result) => Boolean(result.value));
        });
      },
      persistProduct: function() {
        const productCopy = this.deepCopyObject(this.productDetail);        

        const productObj = {
          product: productCopy,
          productVariables: productCopy.productvariables,
        };

        saveProduct(productObj)
        .then((response) => {
          this.productDetail = response.data.product;
          this.productDetail.productvariables = response.data.productVariables;
          this.savedProductDescription = this.productDetail.description;
          this.showSuccess("Save Success");
        })
        .catch((error) => {
          console.error(error.response.data);
          this.showError("Error saving product", error.response);
        });
      },
      goToRandomSale: function() {
        getRandomSaleForProduct(this.productNumber)
        .then((response) => {
          this.randomSale = response.data;

          const routeLocation = {
            name: "search",
            query: {
              saleNumber: this.randomSale.saleNumber,
            },
          };
          const { href } = this.$router.resolve(routeLocation);
          window.open(href, '_blank');        
        }).catch((error) => {
          console.error(error.response.data);
          this.showError("Error fetching random sale", error.response);
        });
      },
      goToProductsList: function() {
        this.$router.go(-1);
      },
      getProductVarTypeClass: function(type) {
        switch (type) {
          case "STRING":
            return "bg-green";
          case "DOUBLE":
            return "bg-warning";
          case "INTEGER":
            return "bg-primary";
        }
      },
      getProductTypes: function() {
          getProductClassificationTypes()
          .then((response) => {
            this.productClassificationTypes = response.data;
          })
          .catch((error) => {
            console.error(error.response.data);
            this.showError("Error fetching product classification types", error.response);
          });
      },
      getRestrictions: function() {
          getProductRestrictions()
          .then((response) => {
            this.productRestrictions = response.data;
          })
          .catch((error) => {
            console.error(error.response.data);
            this.showError("Error fetching product restrictions", error.response);
          });
      },
      getWizardRestrictions: function() {
        getProductWizardRestrictions()
        .then((response) => {
          this.wizardRestrictions = response.data;  
        })
        .catch((error) => {
          console.error(error.response.data);
          this.showError("Error fetching product wizard restrictions", error.response);
        })
      },
      getProductSuppliers: function() {
        getSuppliers()
        .then((response) => {
          this.suppliers = response.data; 
        })
        .catch((error) => {
          console.error(error.response.data);
          this.showError("Error fetching product suppliers", error.response);
        });
      },
      getProductVendors: function() {
        getVendors()
        .then((response) => {
          this.vendors = response.data;  
        })
        .catch((error) => {
          console.error(error.response.data);
          this.showError("Error fetching product vendors", error.response);
        });
      },
      getProductSegments: function() {
        getSegments()
        .then((response) => {
          this.segments = response.data;   
        })
        .catch((error) => {
          console.error(error.response.data);
          this.showError("Error fetching product segments", error.response);
        });
      },
      getSubSegmentsForSegment: function(segmentNumber) {
        getSubSegments(segmentNumber)
        .then((response) => {
          this.subSegments = response.data;
        })
        .catch((error) => {
          console.error(error.response.data);
          this.showError("Error fetching product segments", error.response);
        });
      },
      getSaleDefinitions: function() {
        const productType = this.productDetail.definitionType;
        
        if (productType === "Old") {
          getLegacySaleDefinitions()
          .then((response) => {
            this.saleDefinitions = response.data;
          })
          .catch((error) => {
            console.error(error.response.data);
            this.showError("Error fetching legacy sale definitions", error.response);
          });

          return;
        }

        getSaleDefinitions()
        .then((response) => {
          this.saleDefinitions = response.data;
        })
        .catch((error) => {
          console.error(error.response.data);
          this.showError("Error fetching sale definitions", error.response);
        });
      },
      getProductVariables: function () {
        getSaleDefinitionProductVariables(this.productNumber)
        .then((response) => {
          if (!this.productNumber || this.productNumber == 0) {
                this.productDetail.productvariables = response.data;
              } else {
                const currentProductVarsForSaleDef = response.data;

                currentProductVarsForSaleDef.map((cpv) => {
                  const index = this.inititalProductVariables.findIndex((ipv) =>
                      ipv.name === cpv.name
                  );

                  if (index === -1) {
                    const toAdd = this.deepCopyObject(cpv);
                    toAdd.added = true;
                    this.productDetail.productvariables.push(toAdd);
                  }
                });

                this.productDetail.productvariables.map((ipv) => {
                  const index = currentProductVarsForSaleDef.findIndex(
                    (cpv) => cpv.name === ipv.name
                  );

                  if (index == -1) {
                    ipv.removed = true;
                  }
                });
              }
        })
        .catch((error) => {
          console.error(error.response.data);
          this.showError("Error fetching product variables", error.response);
        });
      },
      cloneProduct: function() {
        getProductClone(this.productNumber)
        .then((response) => {
          this.$router.replace({
              name: "productdetail",
              params: {
                productNumber: response.data.productNumber,
              },
            });
            this.productDetail = response.data;
            this.showSuccess("Successfully cloned product");
          })
        .catch((error) => {
          console.error(error.response.data);
          this.showError("Error fetching product clone", error.response);
        });
      },
      deleteProduct: function() {
        this.$swal({
          title: `Are you sure you want to delete product #${this.productNumber} ?`,
          text: "Only unused products can be deleted",
          type: "warning",
          showCancelButton: true,
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes",
        }).then((result) => {
          if (result.value) {
            deleteProduct(this.productNumber)
            .then(() => {
              this.showSuccess("Successfully deleted Product");
              this.goToProductsList();
            })
            .catch((error) => {
              console.error(error.response.data);
              this.showError("Error deleting product", error.response);
            });
          }
        });
      },
      getSupplier: function(product) {
        let supplier = this.suppliers.filter((s) => s.supplierNumber === product.supplierNumber); 
        if (supplier[0] != null) {
          return supplier[0].name;
        }     
        return "Supplier not found";
      },
      getVendor: function(product) {
        let vendor = this.vendors.filter((v) => v.vendorNumber === product.vendorNumber); 
        if (vendor[0] != null) {
          return vendor[0].name;
        }     
        return "Vendor not found";
      }
    },
  }
</script>

<style lang="scss" scoped>
 .product-var-removed {
    color: red;
  }

  .product-var-added {
    color: green;
  }
</style>
